<template>
  <v-app class="custom_bg">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-title class="px-6">Sales Report</v-card-title>
            <v-card-text>
              <v-col cols="12" md="6" class="py-0">
                <span> Customer Name (optional)</span>
                <v-text-field
                  name="name"
                  outlined
                  dense
                  v-model="form.customer"
                  id="id"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span>Start Date</span>
                <v-text-field
                  name="name"
                  outlined
                  dense
                  v-model="form.start_date"
                  type="date"
                  id="id"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span>End Date</span>
                <v-text-field
                  name="name"
                  outlined
                  dense
                  v-model="form.end_date"
                  type="date"
                  id="id"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <span>Email</span>
                <v-text-field
                  name="name"
                  outlined
                  dense
                  v-model="form.email"
                  id="id"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span>Choose a staff (optional)</span>

                <v-select
                  outlined
                  dense
                  v-model="form.staff_id"
                  :items="staffs"
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-card-actions>
                  <v-snackbar v-model="alert" color="success">
                    {{ msg }}
                  </v-snackbar>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    class="text-capitalize"
                    @click="save()"
                    :loading="loading"
                    >Generate Report</v-btn
                  >
                </v-card-actions>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    form: {
      customer: "",
      email: "",
      staff_id: "",
      start_date: "",
      end_date: "",
    },

    names: [],
    staffs: [],
    loading: false,
    alert: false,
    msg: "",
  }),

  methods: {
    save() {
      this.loading = true;
      fetch("https://receipt.drecsoft.com/api/v1/sales/report", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.currentUser}`,
        },
        body: JSON.stringify(this.form),
      })
        .then((response) => response.json())
        .then((response) => {
          this.msg = response.message;
          this.loading = false;
          this.alert = true;
          this.form.customer = "";
          this.form.email = "";
          this.form.staff_id = "";
          this.form.start_date = "";
          this.form.end_date = "";
        })

        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    fetchStaffs() {
      fetch("https://receipt.drecsoft.com/api/v1/business/all-staff", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.currentUser}`,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          this.staffs = response.staffs;

          console.log(response.staffs);
        })

        .catch((err) => {
          console.log(err);
        });
    },
  },

  mounted() {
    this.fetchStaffs();
  },

  computed: {
    ...mapGetters(["getUser", "currentUser"]),
  },
};
</script>

<style scoped>
.custom_bg {
  background: #f6f7ff;
}
.scroll {
  overflow-y: scroll;
}
</style>
